import React from 'react';
import classNames from 'classnames';
import { Text } from '@hub/text';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function getHighlightRegex(doUseAutocompleteTags) {
  // The search indexes need to be configured with this. The default is <em> and
  // </em> and we could use dangerouslySetInnerHTML, but that makes me
  // uncomfortable.
  const highlightStart = doUseAutocompleteTags ? '__aa-highlight__' : '__HL_START__';
  const highlightEnd = doUseAutocompleteTags ? '__/aa-highlight__' : '__HL_END__';
  return new RegExp("".concat(highlightStart, "(.*?)").concat(highlightEnd));
}

const MaybeHighlighted = props => props.isHighlighted ? /*#__PURE__*/_jsx("em", {
  "data-id": "search_text-with-highlights_MaybeHighlighted_em",
  children: props.children
}) : /*#__PURE__*/_jsx("span", {
  "data-id": "search_text-with-highlights_MaybeHighlighted_span",
  children: props.children
}); // We can maybe clean up the type safety issues here on a later pass


export const TextWithJustHighlights = _ref => {
  var _hit$_highlightResult, _hit$_highlightResult2, _hit$_highlightResult3;

  let {
    hit,
    field,
    doUseAutocompleteTags,
    supplementaryText
  } = _ref;
  const highlight = (_hit$_highlightResult = hit._highlightResult) === null || _hit$_highlightResult === void 0 ? void 0 : _hit$_highlightResult[field];
  const text = highlight ? (_hit$_highlightResult2 = hit._highlightResult) === null || _hit$_highlightResult2 === void 0 ? void 0 : (_hit$_highlightResult3 = _hit$_highlightResult2[field]) === null || _hit$_highlightResult3 === void 0 ? void 0 : _hit$_highlightResult3.value : hit[field];
  const highlightRegex = getHighlightRegex(Boolean(doUseAutocompleteTags)); // Elements will be a list of [out, in, out, in, ...]. Eg, if we search for
  // "shoe" in "nike shoes", elements will contain ["nike ", "shoe", "s"]

  const elements = text ? text.split(highlightRegex) : [];
  const htmlContent = [];

  for (let i = 0; i < elements.length; i++) {
    const isHighlighted = i % 2 === 1; // eslint-disable-line no-magic-numbers

    htmlContent.push( /*#__PURE__*/_jsx(MaybeHighlighted, {
      isHighlighted: isHighlighted,
      "data-id": "search_text-with-highlights_MaybeHighlighted",
      children: elements[i]
    }, i.toString()));
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [htmlContent, supplementaryText && /*#__PURE__*/_jsx(Text, {
      as: "span",
      color: "manatee",
      "data-id": "search_text-with-highlights_MaybeHighlighted_Text",
      children: supplementaryText
    })]
  });
};

const TextWithHighlightsWrappedAndStyled = _ref2 => {
  let {
    isTextBold,
    hit,
    field,
    doUseAutocompleteTags
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(style.textWithHighlights, isTextBold ? style.textBold : ''),
    "data-id": "search_text-with-highlights_MaybeHighlighted_div",
    children: /*#__PURE__*/_jsx(TextWithJustHighlights, {
      hit: hit,
      field: field,
      doUseAutocompleteTags: doUseAutocompleteTags,
      "data-id": "search_text-with-highlights_MaybeHighlighted_div_TextWithJustHighlights"
    })
  });
};

export default TextWithHighlightsWrappedAndStyled;